<template>
  <div>
    <div class="box">
      <resumeHeadS title="简历模板使用" />
      <div class="box-topImg">
        <img src="@/assets/image/resumeLogin/banner2.png" alt="" />
      </div>
      <!-- word模板区域 -->
      <div
        v-if="resumeTemplateObj"
        class="word-box"
      >
        <div class="wordBoxlist">
          <div class="word-from">
            <div
              v-for="(item, index) in resumeTemplateObj.data"
              :key="index"
              class="board"
            >
              <el-image :src="item.img" class="boardImg" lazy></el-image>
              <div class="wrap-mask">
                <div class="glass-wrapper">
                  <div
                    @click="onOpenWindowsFn(item)"
                    class="glass"
                  >
                    <img src="@/assets/image/resumeLogin/放大镜.png" alt="" />
                  </div>
                </div>
                <div
                  @click.stop="onSkipPageFn(`/resume/edit?type=add&oJson=${JSON.stringify(item)}`)"
                  class="download"
                >立即使用</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 预览word弹窗部分 -->
      <el-dialog
        :visible.sync="centerDialogVisible"
        :show-close="false"
        width="524px"
        top="60px"
        center
      >
        <img v-if="currentItem" :src="currentItem.img" alt="" class="word_Img" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="onSkipPageFn(`/resume/edit?type=add&oJson=${JSON.stringify(currentItem)}`)"
            class="wordFn"
          >立即使用</el-button>
          <el-button
            @click="centerDialogVisible = false"
            class="close"
          >关闭</el-button>
        </span>
      </el-dialog>
    </div>
    <MenuStructure class="menuStructure" :control="true" type="/resume/resume_template" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MenuStructure from '@/components/MenuStructure'
import resumeHeadS from '@/components/resumeHeadS.vue'

export default {
  components: {
    MenuStructure,
    resumeHeadS
  },
  data() {
    return {
      centerDialogVisible: false, // 控制预览弹窗
      resumeTemplateObj: null, // 简历模版对象
      currentItem: null, // 当前预览简历属性
      resumeSubmitObj: {
        page: 1,
        page_size: 9999
      }
    }
  },
  created() {
    this.getResumeTemplateFn()
  },
  methods: {
    ...mapActions(['getResumeTemplate']),
    // 获取在线模板简历列表
    async getResumeTemplateFn() {
      this.resumeTemplateObj = await this.getResumeTemplate(this.resumeSubmitObj)
    },
    // 选择当前简历
    onOpenWindowsFn(item) {
      this.centerDialogVisible = true
      this.currentItem = item
    },
    // 跳转页面
    onSkipPageFn(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="stylus">
.box
  padding-top 60px
  .box-topImg
    margin-bottom 24px
  .word-box
    width 1200px
    height auto
    background #FFFFFF
    box-shadow 0 0 20px 0 rgba(221, 221, 221, 0.4)
    border-radius 10px
    margin 0 auto
  .word-box
    padding 40px 50px 0 50px
    .wordBoxlist
      .word-from
        display flex
        flex-wrap wrap
        .board
          position relative
          cursor pointer
          width 220px
          height 310px
          border 0 solid #003DBB
          margin-right 25px
          margin-bottom 25px
          box-shadow 0 0 20px 0 rgba(221, 221, 221, 0.4)
          border-radius 10px
          &:hover
            .wrap-mask
              opacity 1
          .wrap-mask
            position absolute
            top 0
            left 0
            background-color rgba(0, 0, 0, 0.2)
            width 100%
            height 100%
            border-radius 10px
            transition 0.5s
            z-index 10
            opacity 0
            .glass-wrapper
              width 100%
              height auto
              padding 10px 15px
              display flex
              justify-content end
              box-sizing border-box
              .glass
                width 30px
                height 30px
                border-radius 4px
                display flex
                align-items center
                justify-content center
                background #FFFFFF
                img
                  width 16px
                  height 16px
            .download
              width 110px
              height 40px
              margin 200px auto 0 auto
              border-radius 4px
              font-size 18px
              font-family Source Han Sans CN
              font-weight 400
              color #FFFFFF
              line-height 40px
              text-align center
              background #003DBB
        .board:nth-child(5n)
          margin-right 0
        .boardImg
          width 100%
          height 100%
          border-radius 10px
          img
            width 100%
            height 100%
  .wordImg
    width 524px
    height 765px
    background #FFFFFF
    border 0 solid #D1D1D1
    border-radius 6px
    img
      width 100%
      height 100%
  .word_Img
    border-radius 6px
    box-shadow 0 0 20px 0 rgba(0, 0, 0, 0.2)
  /deep/ .el-button.wordFn
    width 110px
    background #003DBB
    border-radius 4px
    font-size 18px
    font-family Source Han Sans CN
    font-weight 400
    color #FFFFFF
  /deep/ .el-button.wordFn:hover
    opacity 0.8
  /deep/ .el-button.close.el-button--default
    width 111px
    background #FFFFFF
    border 1px solid #CCCCCC
    border-radius 4px
    font-size 18px
    font-family Source Han Sans CN
    font-weight 400
    color #666666
  /deep/ .el-button.close.el-button--default:hover
    opacity 0.8
  /deep/ .el-dialog__header
    padding 0
  /deep/.el-dialog--center .el-dialog__body
    padding 25px 25px 9px
  /deep/ .el-dialog.el-dialog--center
    border-radius 5px
.menuStructure
  top 393px
  right 60px
  position fixed
/deep/.el-dialog__wrapper.Emil
  .el-dialog__header
    padding 20px 20px 10px
/deep/ .el-dialog
  border-radius 10px
/deep/ .el-input__inner:focus
        border-color #003dbb
</style>
